/* eslint-disable import/order */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import { Stores } from 'configs';
import { Provider } from 'mobx-react';
import { ErrorBoundary } from 'components/errorBoundary';
import { TranslationProvider } from 'configs/translationContext';
import MembershipService from 'modules/membership/MembershipService';
import { AuthService } from 'modules/auth';
import GtagService from 'modules/app/services/ga/GtagService';
import { UserStore } from 'modules/user';

import { UploadCenter, UploadEventsHandler } from '@hotmart/club-files-ui';

import 'components/CosmosComponents';
import '@hotmart/club-custom-components/dist/styles.css';
import 'components/svg/index.font.js';
import 'modules/app/components/base.scss';
import 'modules/app/components/fixExternalLeak.scss';
import 'configs/styles/tailwind.css';
import '../../../interceptors';
import { setConfiguration } from 'react-grid-system';
import appWrapperUtil from './appWrapperUtil';
import Content from './content';

setConfiguration({ maxScreenClass: 'xl' });

UploadEventsHandler.start(GtagService);

class AppWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true
    };

    MembershipService.setSubdomain(props.subdomain);
  }

  async startup() {
    const { locale } = this.props;

    await Promise.all([
      MembershipService.init(),
      AuthService.initNewSession(locale)
    ]);

    const userId = UserStore.marketplaceId;

    appWrapperUtil.initFeatures(MembershipService.productId);
    appWrapperUtil.initFeaturesByUser(userId);
    this.reenableScroll();
    this.setState({ loading: false });
  }

  componentDidMount() {
    this.startup();
  }

  reenableScroll() {
    // Overflow is set to hidden in index.html to disable scroll during loading
    document.body.style.overflow = 'visible';
  }

  render() {
    const { className, subdomain, basename, children } = this.props;

    return (
      <div id="ClubAdminApp" className="ClubAdminApp">
        <div className={className}>
          <ErrorBoundary>
            <Provider {...Stores}>
              <TranslationProvider>
                <UploadCenter subdomain={subdomain}>
                  <Content basename={basename} loading={this.state.loading}>
                    {children}
                  </Content>
                </UploadCenter>
              </TranslationProvider>
            </Provider>
          </ErrorBoundary>
        </div>
        {/* Container for club-files-ui modals */}
        <div id="app" style={{ height: 0 }} />
      </div>
    );
  }
}

AppWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  subdomain: PropTypes.string.isRequired,
  basename: PropTypes.string.isRequired,
  className: PropTypes.string,
  locale: PropTypes.string,
  roles: PropTypes.arrayOf(PropTypes.string)
};

AppWrapper.defaultProps = {
  basename: '',
  className: '',
  roles: []
};

export default hot(AppWrapper);
